export default "__VITE_ASSET__Bw6TNRvb__"